import { createContext, useContext, useState } from 'react';
import { Theme, themes } from '../config/themes';

interface ThemeContextType {
  currentTheme: Theme;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const defaultTheme: any = themes[0] || {
    name: 'default',
    primary: '#000',
    secondary: '#fff',
    background: '#fff',
    text: '#000',
  };
  const [currentTheme, setTheme] = useState<Theme>(defaultTheme);

  return (
    <ThemeContext.Provider value={{ currentTheme, setTheme }}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};




// import React, { createContext, useState, useEffect, useContext, ReactNode } from 'react'

// interface ThemeContextType {
//   theme: 'light' | 'dark'
//   toggleTheme: () => void
// }

// const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

// export const useTheme = () => {
//   const context = useContext(ThemeContext)
//   if (!context) {
//     throw new Error('useTheme must be used within a ThemeProvider')
//   }
//   return context
// }

// interface ThemeProviderProps {
//   children: ReactNode
// }

// export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
//   const [theme, setTheme] = useState<'light' | 'dark'>('light')

//   useEffect(() => {
//     const savedTheme = localStorage.getItem('theme') || 'light'
//     setTheme(savedTheme as 'light' | 'dark')
//     document.body.classList.add(savedTheme)
//   }, [])

//   const toggleTheme = () => {
//     const newTheme = theme === 'light' ? 'dark' : 'light'
//     setTheme(newTheme)
//     localStorage.setItem('theme', newTheme)
//     document.body.classList.remove(theme)
//     document.body.classList.add(newTheme)
//   }

//   return (
//     <ThemeContext.Provider value={{ theme, toggleTheme }}>
//       {children}
//     </ThemeContext.Provider>
//   )
// }
